import axios from "axios";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setUser } from "../store/UserSlice/userSlice";
import apiUrl from "../libs/baseUrl";

function useLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // استبدال optional chaining بصيغة متوافقة
  const from =
    location &&
    location.state &&
    location.state.from &&
    location.state.from.pathname
      ? location.state.from.pathname
      : '/emp';

  //===State start here===
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  //===State end here===

  // Create configured Axios instance
  const api = axios.create({
    baseURL: apiUrl,
    timeout: 15000,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache'
    },
    transformRequest: [function (data) {
      return JSON.stringify(data);
    }],
  });

  const handleLogin = async (jobId, password, rememberMe) => {
    try {
      setLoading(true);
      setErrorMessage('');

      // First attempt with Axios
      try {
        const response = await api.post('/auth/login', {
          job_id: jobId,
          password: password,
        });

        if (response.data) {
          // استبدال optional chaining داخل response
          const token =
            response.data && response.data.data && response.data.data.token
              ? response.data.data.token
              : null;

          if (token) {
            dispatch(setUser({ token, rememberMe }));
            navigate(from, { replace: true });
            return;
          } else {
            throw new Error('No token received from response');
          }
        }
      } catch (axiosError) {
        // If Axios fails, try with fetch API
        if (axiosError.code === 'ERR_NETWORK' || axiosError.message === 'Network Error') {
          await attemptFetchFallback(jobId, password, rememberMe);
          return;
        }
        throw axiosError;
      }
    } catch (error) {
      setLoading(false);
      console.error('Full error:', error);

      // Handle error
      if (error.response) {
        if ([401, 422, 404].includes(error.response.status)) {
          setErrorMessage("بيانات الاعتماد غير صحيحة");
        } else if (
          error.response.data &&
          error.response.data.message
        ) {
          setErrorMessage(error.response.data.message);
        } else {
          setErrorMessage("حدث خطأ في السيرفر");
        }
      } else if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
        setErrorMessage("هنالك مشكلة في الاتصال بالانترنت يرجى المحاولة لاحقا");
      } else if (error.code === 'ECONNABORTED') {
        setErrorMessage("انتهى وقت الانتظار يرجى المحاولة مرة أخرى");
      } else {
        setErrorMessage(error.toString());
      }
    }
  };

  // Fallback to Fetch API when Axios fails
  const attemptFetchFallback = async (jobId, password, rememberMe) => {
    try {
      const response = await fetch(`${apiUrl}/auth/login`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          job_id: jobId,
          password: password
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Fetch request failed');
      }

      const data = await response.json();

      // استبدال optional chaining هنا أيضًا
      const token =
        data && data.data && data.data.token ? data.data.token : null;

      if (token) {
        dispatch(setUser({ token, rememberMe }));
        navigate(from, { replace: true });
      } else {
        throw new Error('No token received');
      }
    } catch (error) {
      console.error('Fetch fallback failed:', error);
      throw error;
    }
  };

  return { handleLogin, loading, errorMessage };
}

export default useLogin;
